<template>
    <solid-box :title="moduleName">
        <table-info :columns="columns" :table-data="tableData" />
    </solid-box>
</template>

<script>
import TableInfo from '@/components/TableInfo'
import * as screenAPI from '@/api/screen'
import eventHub from '@/utils/eventHub'
import SolidBox from '@/components/SolidBox'
// import env from '@/config/env'

/**
 * 成交公告
 */
export default {
    components: {
        TableInfo,
        SolidBox
    },
    props: {
        moduleName: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            columns: [
                { title: '项目名称', field: 'title', width: '40%' },

                { title: '成交价格', field: 'price', type: 'emphasize' },
                { title: '成交时间', field: 'time' }
            ],
            tableData: []
        }
    },
    methods: {
        async getProjectList() {
            const params = {
                resource: this.$route.name === 'haiken' ? 2 : undefined,
                siteId:
                    this.$route.params.id === 'zhongguo'
                        ? 0
                        : this.$route.params.id
            }
            const response = await screenAPI.tranannouncements(params)
            if (response && response.data) {
                this.tableData = response.data || []
                for (let i = 0; i < this.tableData.length; i++) {
                    this.tableData[i].time = this.tableData[
                        i
                    ].customs.trans_date
                    this.tableData[i].price = this.tableData[i].customs.prices
                }
                // 2022-07-27 针对湖南线上大屏做的特殊处理
                // let data = []
                // if (this.$route.params.id === env.HNLOCID) {
                //     for (let i = 0; i < this.tableData.length; i++) {
                //         if (this.tableData[i].time.includes('2022-')) {
                //             data.push(this.tableData[i])
                //         }
                //     }
                //     this.tableData = data
                // }
            }
        }
    },
    mounted() {
        eventHub.$on('areaChange', () => {
            this.tableData = []
            this.getProjectList()
        })
        this.getProjectList()
    }
}
</script>

<style></style>
